import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { $bluishGray60 } from 'styles/colors';

const styles = {
	labelStyle: {
		padding: '5px 0',
		fontSize: '12px',
		lineHeight: '13px',
		textTransform: 'uppercase',
		color: $bluishGray60,
		fontWeight: 600
	}
};

const CustomInputLabel = ({ text }) => {
	const useStyles = makeStyles(styles);
	const classes = useStyles();

	return <Typography className={classes.labelStyle}>{text}</Typography>;
};

export default CustomInputLabel;
